import {ActionTypes} from '../actions';
import {Parts} from '../../common/actionTypes';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loadingList': false,
  'list': [],
  'page': [],
  'itemsCount': 0,
  'pageSize': 20,
  'pageNumber': 0,
  'filterCodeText': '',
  'filterDescriptionText': '',
  'loading': false,
  'partWatching': {},
  'loadingSales': false,
  'sales': [],
  'loadingOnOrders': false,
  'onOrders': [],
  'loadingReceptionsOrders': false,
  'receptionsOrders': [],
};

export const partWatching = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [Parts.CLEAR_FILTERS]: (state, action) => ({
      ...state,
      'loadingList': false,
      'list': [],
      'page': [],
      'itemsCount': 0,
      'filterCodeText': '',
      'filterDescriptionText': '',
    }),
    [Parts.FETCHING_PARTS_LIST]: (state, action) => ({
      ...state,
      'loadingList': true,
    }),
    [Parts.FETCHED_PARTS_LIST]: (state, action) => ({
      ...state,
      'list': action.response.data,
      'page': action.response.data,
      'itemsCount': action.response.count,
      'loadingList': false,
    }),
    [Parts.FETCHED_PARTS_LIST_FAILED]: (state, action) => ({
      ...state,
      'list': [],
      'page': [],
      'itemsCount': 0,
      'loadingList': false,
    }),

    [Parts.CHANGE_CODE_TEXT_FILTER]: (state, action) => ({
      ...state,
      'filterCodeText': action.payload,
    }),
    [Parts.CHANGE_DESCRIPTION_TEXT_FILTER]: (state, action) => ({
      ...state,
      'filterDescriptionText': action.payload,
    }),
    [ActionTypes.CHANGE_PART_WATCHING_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
    }),
    [ActionTypes.CHANGE_PART_WATCHING_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
    }),
    [ActionTypes.CLEAR_PART_WATCHING]: (state, action) => ({
      ...state,
      'loading': false,
      'partWatching': {},
      'loadingSales': false,
      'sales': [],
      'loadingOnOrders': false,
      'onOrders': [],
      'loadingReceptionsOrders': false,
      'receptionsOrders': [],
    }),
    [ActionTypes.FETCHING_PART_WATCHING]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_PART_WATCHING]: (state, action) => ({
      ...state,
      'loading': false,
      'partWatching': action.response.data,
    }),
    [ActionTypes.FETCHED_PART_WATCHING_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'partWatching': {},
    }),
    [ActionTypes.FETCHING_SALES_BY_YEAR_AND_MONTH]: (state, action) => ({
      ...state,
      'loadingSales': true,
    }),
    [ActionTypes.FETCHED_SALES_BY_YEAR_AND_MONTH]: (state, action) => ({
      ...state,
      'loadingSales': false,
      'sales': action.response.data,
    }),
    [ActionTypes.FETCHED_SALES_BY_YEAR_AND_MONTH_FAILED]: (state, action) => ({
      ...state,
      'loadingSales': false,
      'sales': [],
    }),
    [ActionTypes.FETCHING_ON_ORDERS_BY_YEAR_AND_MONTH]: (state, action) => ({
      ...state,
      'loadingOnOrders': true,
    }),
    [ActionTypes.FETCHED_ON_ORDERS_BY_YEAR_AND_MONTH]: (state, action) => ({
      ...state,
      'loadingOnOrders': false,
      'onOrders': action.response.data,
    }),
    [ActionTypes.FETCHED_ON_ORDERS_BY_YEAR_AND_MONTH_FAILED]: (state, action) => ({
      ...state,
      'loadingOnOrders': false,
      'onOrders': [],
    }),
    [ActionTypes.FETCHING_RECEPTIONS_ORDERS_BY_YEAR_AND_MONTH]: (state, action) => ({
      ...state,
      'loadingReceptionsOrders': true,
    }),
    [ActionTypes.FETCHED_RECEPTION_ORDERS_BY_YEAR_AND_MONTH]: (state, action) => ({
      ...state,
      'loadingReceptionsOrders': false,
      'receptionsOrders': action.response.data,
    }),
    [ActionTypes.FETCHED_RECEPTION_ORDERS_BY_YEAR_AND_MONTH_FAILED]: (state, action) => ({
      ...state,
      'loadingReceptionsOrders': false,
      'receptionsOrders': [],
    }),
  })(state, action);
};
